export const formOptions = {
  nature: {
    rules: [{ required: true, message: 'Por favor, selecione uma natureza' }],
  },
  type: {
    rules: [{ required: true, message: 'Por favor selecione um tipo' }],
  },
};
